import styled from "styled-components";

const FooterStyle = styled.div` 
 clear: both;
  .fotter_section { 
   background-image: linear-gradient(90deg, #e40685 0%, #bd1b86 21%, #632e8a 100%);  
    padding: 60px 0px 70px; 
    @media (max-width: 1280px){
      padding: 50px 0px 40px; 
      }
    .footer_first_section {
    margin-bottom: 60px;
    position: relative;
    z-index: 1;
    @media (max-width: 1280px){
      margin-bottom: 30px;
    }
  }
    .fotter-logo { 
      img {
        width: 100%;
        max-width: 180px;
      }
      margin: 0 auto;
    }
    .container >.row {
    display: flex;
    justify-content: space-between;
    @media (max-width: 767px){
      flex-wrap: wrap;
    }
    & ::before,& ::after{
      display: none;
    }
    @media (max-width: 767px){
      .col-md.left-border {
        border-top: 2px solid #fff;
        padding-top: 5px;
        margin-top: 20px;
      }
    }
          .col-md {
          max-width: calc(100%/4 - 10px);
          flex: 1;
            @media (max-width: 767px){
            max-width: 100%;    flex: 100%;
            } 
         }
            .d-flex{ 
                  flex-wrap: wrap; 
              .footer_link {
              display: block;
              width: 100%;
              font-size: 22px;
              color: #ffffff;
              font-family: var(--common-font);
              border-left: 2px solid #fff;
              padding-left: 20px;
              line-height: normal;
              @media (max-width: 1280px){
                font-size: 20px;
              }
              @media (max-width: 1199px){
                font-size: 18px;
              }
              @media (max-width: 767px){
                padding: 10px 0 0;
                border: none;
                text-align: center;
                font-size: 16px;
              }
              &:not(:last-child){
                padding-bottom: 15px;
                cursor: pointer;
                @media (max-width: 1280px){
                  padding-bottom: 10px;
              }
              @media (max-width: 767px){
                  padding-bottom: 0px;
              }
              }
            }
          }
            .footer_section {
                text-align: center;
                max-width: 236px;
                @media (max-width: 1280px){
                  max-width: 100%;
                }
              img {
                  filter: invert(1);
                  margin-bottom: 10px;
                  max-width: 120px;
                  @media (max-width: 767px){
                    max-width: 90px;
                  }
                  }
              p{
                font-size: 22px;
                color: #ffffff;
                font-family: var(--common-font);
                text-align: center;
                margin-bottom: 25px;

                @media (max-width: 1199px){
                  font-size: 18px; 
                }
               
                @media (max-width: 767px){
                  font-size: 16px; 
                  margin-bottom: 15px;
                  }

              }
        } 
  } 
  .container_footer {
 padding-left: 15px;
 padding-right: 15px;
    > div > p {
    font-size: 22px;
    color: #ffffff;
    font-family: var(--common-font);
    text-align: center;
    margin-bottom: 0;
    @media only screen and (max-width:1199px) {
      font-size: 18px;
    }
      @media (max-width: 767px){
        font-size: 16px;
        line-height: normal;
        }
      
  }
  }
  .socialIcons {
    display: flex;
    justify-content: center;
    a {
      margin: 0 7.5px; 
      img {
    width: 100%;
    max-width: 36px!important;
    margin: 0;
      }
    }    
    }
    
    /* .fotter_section .container >.row .footer_section .socialIcons {
    max-width: 27px;
    margin-right: 10px;
}

.fotter_section .container >.row .footer_section .socialIcons img {
    width: 100%;
    height: 20px;
    object-fit: contain;
}

.jgMGMd .fotter_section .container >.row .footer_section {
    display: flex;
    flex-wrap: wrap;
} */
  }
  .copyright_issue {
    p:last-child {
      font-size: 18px !important;

      @media only screen and (max-width: 1199px) {
        font-size: 16px !important;
      }

      @media only screen and (max-width: 767px) {
        font-size: 14px !important;
      }
    }
  }

  .referrer-color-cstm::selection {
    color: white;
    background-color: red;
  }
`;
export default FooterStyle;
